import * as types from '../actions';

export default function setVolID(volID) {
  return {
    type: types.VIEWER_SET_VOL_ID,
    volID,
  };
}
